export type Theme = 'system' | 'light' | 'dark'

const KEY = 'val.theme'
export const THEME_ORDER: Theme[] = ['system', 'light', 'dark']

export function getStoredTheme(): Theme {
  try {
    const t = localStorage.getItem(KEY)
    if (t === 'light' || t === 'dark' || t === 'system') return t
  } catch {
    /* ignorera */
  }
  return 'system'
}

export function applyTheme(theme: Theme): void {
  const el = document.documentElement
  if (theme === 'system') el.removeAttribute('data-theme')
  else el.setAttribute('data-theme', theme)
}

export function setTheme(theme: Theme): void {
  try {
    if (theme === 'system') localStorage.removeItem(KEY)
    else localStorage.setItem(KEY, theme)
  } catch {
    /* ignorera */
  }
  applyTheme(theme)
}

export function systemPrefersDark(): boolean {
  return (
    typeof window !== 'undefined' && window.matchMedia?.('(prefers-color-scheme: dark)').matches
  )
}

export function resolvedTheme(theme: Theme): 'light' | 'dark' {
  return theme === 'system' ? (systemPrefersDark() ? 'dark' : 'light') : theme
}

const LABELS: Record<Theme, string> = { system: 'Följ systemet', light: 'Ljust', dark: 'Mörkt' }
export const themeLabel = (t: Theme) => LABELS[t]
